// The screens this app has, generated from .appfactory/product-plan.json.
//
// Imported by the navigation shell rather than replacing it: the shell owns
// router.js — bottom-tabs, stack and sidebar produce different routers, and it
// rewrites that file on every `spec apply`. Two owners for one file is a silent
// fight, so the product contributes ROUTES and the shell decides what to do
// with them.
//
// `primary` marks a screen that earns a place in the navigation itself.

import { carSportOutline } from 'ionicons/icons';

import GridPage from './pages/GridPage.vue';
import GaragePage from './pages/GaragePage.vue';
import DrivePage from './pages/DrivePage.vue';
import FlagPage from './pages/FlagPage.vue';
import ChampagnePage from './pages/ChampagnePage.vue';

export const PRODUCT_ROUTES = [
  {
    id: 'grid',
    path: '/',
    label: 'Grid',
    tab: 'Grid',
    icon: carSportOutline,
    component: GridPage,
    primary: true,
    destination: true,
    settings: false,
  },
  {
    id: 'garage',
    path: '/garage',
    label: 'Garage',
    component: GaragePage,
    primary: false,
    destination: false,
    settings: false,
  },
  {
    id: 'drive',
    path: '/drive/:id',
    label: 'Drive',
    component: DrivePage,
    primary: false,
    destination: false,
    settings: false,
  },
  {
    id: 'flag',
    path: '/flag/:id',
    label: 'Chequered flag',
    component: FlagPage,
    primary: false,
    destination: false,
    settings: false,
  },
  {
    id: 'champagne',
    path: '/champagne/:id',
    label: 'Champagne',
    component: ChampagnePage,
    primary: false,
    destination: false,
    settings: false,
  },
];

export const PRIMARY_ROUTES = PRODUCT_ROUTES.filter((r) => r.primary);

// What the navigation offers. NOT the same question as `primary`.
//
// The tab bar was built from PRIMARY_ROUTES, and `primary` means "the screen
// the app opens on" — exactly one screen per plan. So a four-screen app got a
// one-tab tab bar and three screens nothing could reach. `roles` grades
// importance for QA; it was never a claim about navigation.
//
// A destination is a top-level screen someone navigates TO: primary or
// critical, never a detail screen (reached from its list) and never settings
// (which gets its own toolbar button, because a settings tab crowds out a real
// one). Capped at five — past that a bottom bar stops being usable and the
// platform guidelines say so.
export const DESTINATION_ROUTES = PRODUCT_ROUTES.filter((r) => r.destination).slice(0, 5);

// The settings screen, whatever this app decided to CALL it.
export const SETTINGS_ROUTE = PRODUCT_ROUTES.find((r) => r.settings) ?? null;

// WHERE THE APP OPENS, and it must be a path that can actually resolve.
//
// This took the first `primary` route whatever its shape. A plan is free to
// mark a parameterised screen primary — one did: `capture` at
// `/recipe/:recipeId/capture` — and the app then opened on a path with a
// literal `:` in it, which vue-router cannot match and which becomes
// "Missing required param" at boot.
//
// A destination is already defined as top-level and non-detail, so it is the
// right fallback: prefer a primary screen that can resolve, then any
// destination, then anything without a parameter.
const RESOLVABLE = (r) => !/:[A-Za-z]/.test(r.path);
export const HOME_ROUTE = (
  PRIMARY_ROUTES.find(RESOLVABLE)
  ?? DESTINATION_ROUTES.find(RESOLVABLE)
  ?? PRODUCT_ROUTES.find(RESOLVABLE)
)?.path ?? '/';
